import { useNavigate } from "react-router-dom"

const SevenSlide = () => {
  const navigate = useNavigate()

  return (
    <div className="h-screen bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[url('./assets/world-map.png')] bg-cover bg-center blur-sm"></div>
      </div>

      {/* Animated Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-32 h-32 bg-white/5 rounded-full blur-xl animate-pulse"></div>
        <div className="absolute bottom-32 right-16 w-24 h-24 bg-purple-400/10 rounded-full blur-lg animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-pink-400/10 rounded-full blur-md animate-pulse delay-500"></div>
      </div>

      <div className="relative z-10 flex flex-col h-screen overflow-hidden">
        {/* Logo Section */}
        <div className="flex-shrink-0 p-6 pt-12">
          <div className="max-w-xs mx-auto">
            <img className="w-full h-auto drop-shadow-2xl" src="/assets/appFullLogo.png" alt="App Logo" />
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 flex flex-col justify-center items-center px-6 text-center">
          <div className="max-w-md mx-auto">
            {/* Title */}
            <h1 className="text-4xl md:text-5xl font-light text-white mb-8 leading-tight">The Kirana Point</h1>

            {/* Welcome Message */}
            <div className="mb-12">
              <div className="bg-white/10 backdrop-blur-xl rounded-2xl p-8 border border-white/20 shadow-2xl">
                <p className="text-3xl md:text-4xl font-light text-white mb-2">Let's Get</p>
                <p className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent">
                  Started!
                </p>
              </div>
            </div>

            {/* CTA Button */}
            <button
              onClick={() => navigate("/")}
              className="group relative w-full max-w-xs mx-auto px-8 py-4 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-2xl font-semibold text-xl shadow-2xl hover:shadow-pink-500/25 transform hover:scale-105 transition-all duration-300 overflow-hidden"
            >
              <span className="relative z-10 flex items-center justify-center gap-3">
                Get Started
                <svg
                  className="w-6 h-6 group-hover:translate-x-1 transition-transform duration-200"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </span>

              {/* Button shine effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
            </button>

            {/* Subtitle */}
            <p className="text-white/70 text-sm mt-6 font-medium">Your journey begins here</p>
          </div>
        </div>

        {/* Bottom Decoration */}
        <div className="flex-shrink-0 h-16 bg-gradient-to-t from-black/20 to-transparent"></div>
      </div>
    </div>
  )
}

export default SevenSlide
